module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel06_770_280_zh-hant-a0abf86f2ee6c0daf3249fd6787722b5.jpg";